/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Autocomplete as NativeAutocomplete,
	AutocompleteProps,
} from '@mantine/core';

// Styles
import classes from './SearchInput.module.css';

// Icons
import { IconSearch } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

export type TTextInputProps = AutocompleteProps;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const SearchInput = (props: TTextInputProps) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeAutocomplete
			comboboxProps={{
				transitionProps: {
					transition: 'pop',
					duration: 200,
				},
				dropdownPadding: 12,
			}}
			size="lg"
			leftSection={
				<IconSearch
					style={{
						rotate: '90deg',
					}}
					size={24}
				/>
			}
			classNames={classes}
			{...props}
		/>
	);
};
